import React, { useState } from "react";
import { PeopleItemModel } from "./PeopleItemModel";
import { ReactComponent as InfoSvg } from "../../../../assets/images/i-icon.svg";

import "./PeopleItem.css";
import Utils from "../../../core/Utils/Utils";

const PeopleItem: React.FC<{ blok: PeopleItemModel }> = ({ blok }) => {
  let [clicked, setClicked] = useState(false);
  const showOpenClass = window.innerWidth < 480 && clicked;

  const handleInfoClick = () => {
    setClicked(!clicked);
  };

  return (
    <div className="list-panel-item " key={`list-panel-item-${blok._uid}`}>
      <InfoSvg className="info-img" onClick={handleInfoClick}></InfoSvg>
      <img
        src={Utils.getCacheUrl(blok.image?.filename)}
        alt=""
        onError={(e) => Utils.handleImageError(e, blok.image.filename)}
      />
      <div className="people-item-content">
        <div className="people-item-role">{blok.role}</div>
        <div className="people-item-title">{`${blok.firstName} ${blok.lastName}`}</div>
      </div>
      <div
        className={`people-item-description ${
          showOpenClass ? "show-on-mobile" : ""
        }`}
        onClick={() => setClicked(false)}
      >
        {blok.description}
      </div>
    </div>
  );
};

export default PeopleItem;
